import React, { useState, useEffect, useMemo } from 'react' 
import Header from '../../components/header/Header'
import MyCheck from './MyCheck/MyCheck'
import DepositBlock from './depositBlock/DepositBlock'
import WithdrawalFunds from './WithdrawalFunds/WithdrawalFunds'
import axios from 'axios'
import './Assets.css'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const Assets = () => {
    const { t } = useTranslation()

    function number_format(number, decimals, dec_point, thousands_sep) {
        number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
        var n = !isFinite(+number) ? 0 : +number,
            prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
            dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
            s = '',
            toFixedFix = function (n, prec) {
                var k = Math.pow(10, prec);
                return '' + Math.round(n * k) / k;
            };
        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        return s.join(dec);
    }

    function createSymbolString(currencyObject) {
        const pairs = Object.keys(currencyObject).map((currency) => {
            return currency.toUpperCase() + "USDT";
        });
        const filteredPairs = pairs.filter((pair) => pair !== "USDTUSDT");
        return filteredPairs.length === 0 ? `symbols=["BNBBTC"]` : `symbols=${JSON.stringify(filteredPairs)}`;
    }
    
    function calculateTotalValue(coinsPrice, currencyObject) {
         let totalValue = 0;
         coinsPrice.forEach((coin) => {
             const { symbol, lowPrice } = coin;
             const currency = symbol === "BNBBTC" ? "usdt" : symbol.replace("USDT", "").toLowerCase();
             const lowpriceNew = symbol === "BNBBTC" ? 1 : lowPrice;
             const rate = (currencyObject[currency] ? currencyObject[currency] : 0);
             const lowPriceNum = parseFloat(lowpriceNew);
             totalValue += lowPriceNum * rate;
         });
         return totalValue > 0 ? totalValue : 0;
    }

    const token = localStorage.getItem("token")
    const navigate = useNavigate()

    const [AVGINVEST, setAVGINVEST] = useState(0);
    const [AVGMAIN, setAVGMAIN] = useState(0);
    const [AVGFUTURES, setAVGFUTURES] = useState(0);
    
    const [AVGMAINLD, setAVGMAINLD] = useState(false);
    const [AVGINVESTLD, setAVGINVESTLD] = useState(false);
    const [AVGFUTURESLD, setAVGFUTURESLD] = useState(false);

    const [balanceFiltered, setBalanceFiltered] = useState([])
    const [balanceFilteredFutures, setBalanceFilteredFutures] = useState([])
    const [balanceFilteredInvest, setBalanceFilteredInvest] = useState([])

    const [AVGMAINLD22, setAVGMAINLD22] = useState(false); 
    const [chekAVGBTC, setChekAVGBTC] = useState(false);   
    const [AVGBALANCE2, setAVGBALANCE2] = useState(0);
    const [AVGMAIN2, setAVGMAIN2] = useState(0);
    const [AVGFUTURES2, setAVGFUTURES2] = useState(0);
    const [AVGINVEST2, setAVGINVEST2] = useState(0);
    const [AVGBTC, setAVGBTC] = useState(0);

    const [depositVisible, setDepositVisible] = useState(false)
    const [withdrawalFundsVisible, setWithdrawalFundsVisible] = useState(false)

    const getBalances = () => {
        axios.get(`https://api-ru.fynex.cc/api/api/users/balance/common`, { headers: { "Authorization": `Bearer ${token}` } })
            .then(res => {
                setAVGBALANCE2(Math.floor10(res.data, -2))
                setAVGMAINLD22(true) 
            })
            .catch(e => setAVGMAINLD22(true)); 

        axios.get(`https://api-ru.fynex.cc/api/api/users/balance/main/common`, { headers: { "Authorization": `Bearer ${token}` } })
            .then(res => setAVGMAIN2(Math.floor10(res.data, -2)))
        axios.get(`https://api-ru.fynex.cc/api/api/users/balance/futures/common`, { headers: { "Authorization": `Bearer ${token}` } })
            .then(res => setAVGFUTURES2(Math.floor10(res.data, -2)))
        axios.get(`https://api-ru.fynex.cc/api/api/users/balance/invest/common`, { headers: { "Authorization": `Bearer ${token}` } })
            .then(res => setAVGINVEST2(Math.floor10(res.data, -2)))
    }

    const [btcRate, setBtcRate] = useState(null); 

    const getBtcRateOnly = () => {
        axios.get('https://api-ru.fynex.cc/rates/rate?ticker=BTC&coin=USDT')
        .then(res => {
            setBtcRate(parseFloat(res.data));
            setChekAVGBTC(true);
        })
        .catch(err => {
            console.error(err);
            setChekAVGBTC(true); 
        });
    }

    useEffect(() => {
        getBalances();
        getBtcRateOnly(); 
        requireBalance();
        requireBalanceFutures();
        requireBalanceInvest();
        getUserPortfolioData();
        requireTransactions();
    }, []);

    useEffect(() => {
        if (AVGBALANCE2 && btcRate) {
            setAVGBTC((parseFloat(AVGBALANCE2) / btcRate).toFixed(6)); 
        }
    }, [AVGBALANCE2, btcRate]);

    function filterKeysWithPositiveValues(obj) {
        const filteredEntries = Object.entries(obj).filter(([key, value]) => value > 0 && key !== 'username_id' && key !== 'id');
        return Object.fromEntries(filteredEntries);
    }

    const requirePrice = async (ignoredUrl, currencyObject, type) => {
        const currencies = Object.keys(currencyObject);
        if (currencies.length === 0) {
            switch (type) {
                case "main": 
                    setAVGMAIN(0); 
                    setAVGMAINLD(true); 
                    break;
                case "invest": 
                    setAVGINVEST(0); 
                    setAVGINVESTLD(true); 
                    break;
                case "futures": 
                    setAVGFUTURES(0); 
                    setAVGFUTURESLD(true); 
                    break;
            }
            return;
        }

        const promises = currencies.map(async (currency) => {
            if (currency.toUpperCase() === 'USDT' || currency.toUpperCase() === 'USD') {
                return { symbol: currency, price: 1, amount: currencyObject[currency] };
            }
            if (currency === 'rub') return { symbol: currency, price: 0, amount: currencyObject[currency] };
            
            try {
                const res = await axios.get(`https://api-ru.fynex.cc/rates/rate`, {
                    params: { ticker: currency.toUpperCase(), coin: 'USDT' }
                });
                return { symbol: currency, price: parseFloat(res.data), amount: currencyObject[currency] };
            } catch (e) {
                return { symbol: currency, price: 0, amount: currencyObject[currency] };
            }
        });

        try {
            const results = await Promise.all(promises);
            let totalValue = 0;
            results.forEach(item => {
                 if (item.symbol !== 'rub') totalValue += (item.price * item.amount);
            });

            switch (type) {
                case "main": setAVGMAIN(totalValue); setAVGMAINLD(true); break;
                case "invest": setAVGINVEST(totalValue); setAVGINVESTLD(true); break;
                case "futures": setAVGFUTURES(totalValue); setAVGFUTURESLD(true); break;
            }
        } catch (error) { console.error(error); }
    }

    const requireBalance = () => {
        axios.get(`https://api-ru.fynex.cc/api/api/users/balance`, {headers: {"Authorization" : `Bearer ${token}`}})
            .then(res => {
                let balanceFilter = filterKeysWithPositiveValues(res.data)
                setBalanceFiltered(Object.entries(balanceFilter));
                requirePrice(null, balanceFilter, "main")
            })
    }
    const requireBalanceInvest = () => {
         axios.get(`https://api-ru.fynex.cc/api/api/users/balance/invest`, {headers: {"Authorization" : `Bearer ${token}`}})
            .then(res => {
                let balanceFilter = filterKeysWithPositiveValues(res.data)
                setBalanceFilteredInvest(Object.entries(balanceFilter));
                requirePrice(null, balanceFilter, "invest")
            })
    }
    const requireBalanceFutures = () => {
        axios.get(`https://api-ru.fynex.cc/api/api/users/balance/futures`, {headers: {"Authorization" : `Bearer ${token}`}})
           .then(res => {
               let balanceFilter = filterKeysWithPositiveValues(res.data)
               setBalanceFilteredFutures(Object.entries(balanceFilter));
               requirePrice(null, balanceFilter, "futures")
           })
   }

    const [transactions, setTransactions] = useState([])
    const requireTransactions = () => {
        axios.get(`https://api-ru.fynex.cc/api/api/transaction`, {headers: {"Authorization" : `Bearer ${token}`}})
            .then(res => setTransactions(res.data))
    }

    (function() {
        function decimalAdjust(type, value, exp) {
            if (typeof exp === 'undefined' || +exp === 0) return Math[type](value);
            value = +value; exp = +exp;
            if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) return NaN;
            value = value.toString().split('e');
            value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
            value = value.toString().split('e');
            return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
        }
        if (!Math.floor10) Math.floor10 = function(value, exp) { return decimalAdjust('floor', value, exp); };
    })();

    const [cursCb, setCursCb] = useState(90);

    const [userPortfolioData, setUserPortfolioData] = useState() 
    const getUserPortfolioData = () => {
        axios.get("https://api-ru.fynex.cc/api/api/user/portfolio", {headers: {"Authorization": `Bearer ${token}`}})
            .then(res => setUserPortfolioData(res.data))
    }

    function formatDate(inputDate) {
        const date = new Date(inputDate);
        return `${date.getFullYear().toString().substr(-2)}.${(date.getMonth()+1).toString().padStart(2,'0')}.${date.getDate().toString().padStart(2,'0')} ${date.getHours().toString().padStart(2,'0')}:${date.getMinutes().toString().padStart(2,'0')}`;
    }
    
    const returnStatus = (status) => {
        if(status == "accepted") return <p className='accepted'>{t("transactions.accepted")}</p>
        if(status == "waiting") return <p className='wait'>{t("transactions.wait")}</p>
        if(status == "rejected") return <p className='rejected'>{t("transactions.rejected")}</p>
    }

    const data = useMemo(() => {
        return [
            { 
                name: t("assets.futures"), 
                value: ` BTC`, 
                percentage: "%", 
                usd: "USD", 
                data: balanceFilteredFutures,
                isLoading: !AVGFUTURESLD 
            },
            { 
                name: t("assets.replenishment"), 
                value: ` BTC`, 
                percentage: "%", 
                usd: "USD", 
                data: balanceFiltered,
                isLoading: !AVGMAINLD 
            },
            { 
                name: t("assets.invest"), 
                value: ` BTC`, 
                percentage: "%", 
                usd: "USD", 
                data: balanceFilteredInvest,
                isLoading: !AVGINVESTLD 
            },
            { 
                name: t("assets.portfel"), 
                value: ` BTC`, 
                percentage: "%", 
                usd: "USD", 
                data: userPortfolioData?.active === false ? [] : [["usd", userPortfolioData?.value]],
                isLoading: !userPortfolioData 
            },
        ];
    }, [balanceFilteredFutures, balanceFiltered, balanceFilteredInvest, userPortfolioData, AVGFUTURESLD, AVGMAINLD, AVGINVESTLD, t]);

    const isHeaderLoading = !AVGMAINLD22 || !chekAVGBTC;

    return (
        <div className='Assets'>
            <div className="WrapperBlock" style={{visibility: depositVisible || withdrawalFundsVisible ? "visible" : "hidden"}}>
                <DepositBlock state={depositVisible} setState={setDepositVisible}/>
                <WithdrawalFunds state={withdrawalFundsVisible} setState={setWithdrawalFundsVisible}/>
            </div>

            <Header hasMenu2={true}/>
            <div className="assetsWrapper">
                <div className="wrapperBlocks">
                    <div className="section">
                        <div className="myActiv">
                            <h2>{t("assets.myActive")}</h2>
                            <div className="countActiv">
                                <p>{t("assets.countActive")}</p>
                                
                                {isHeaderLoading ? (
                                    <div className="skeleton skeleton-title" style={{ width: '220px', height: '36px', marginTop: '10px' }}></div>
                                ) : (
                                    <h2>{AVGBTC} BTC <span> {number_format(AVGBALANCE2, 2)} USD</span></h2>
                                )}
                            </div>
                            <p className='usd'></p>
                        </div>
                        
                        <div className="btnMenu">
                            <button onClick={()=>setDepositVisible(true)}><p>{t("assets.deposit")}</p></button>
                            <button onClick={()=>setWithdrawalFundsVisible(true)}><p>{t("assets.conclusion")}</p></button>
                            <button onClick={()=>navigate('/convert')}><p>{t("assets.convert")}</p></button>
                            <button onClick={()=>navigate('/account/wallet')}><p>{t("assets.transfer")}</p></button>
                        </div>

                        <div className="lastTransaction">
                           <div className="headline">
                                <h2>{t("assets.lastTransactions")}</h2>
                                <p onClick={()=>{navigate("/transactions")}}>{t("assets.more")}<svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.27878 1.08738C7.22457 1.14154 7.18156 1.20585 7.15222 1.27664C7.12288 1.34743 7.10778 1.42331 7.10778 1.49994C7.10778 1.57657 7.12288 1.65245 7.15222 1.72324C7.18156 1.79403 7.22457 1.85834 7.27878 1.91251L9.78303 4.41676H0.691342C0.536671 4.41676 0.388335 4.4782 0.278966 4.58757C0.169597 4.69694 0.108154 4.84527 0.108154 4.99994C0.108154 5.15461 0.169597 5.30295 0.278966 5.41232C0.388335 5.52169 0.536671 5.58313 0.691342 5.58313H9.78303L7.27878 8.08738C7.16936 8.1968 7.10789 8.3452 7.10789 8.49994C7.10789 8.65468 7.16936 8.80309 7.27878 8.91251C7.3882 9.02192 7.5366 9.0834 7.69134 9.0834C7.84608 9.0834 7.99449 9.02192 8.1039 8.91251L11.6039 5.41294V5.41251L11.6052 5.41119C11.6593 5.3573 11.7022 5.2932 11.7314 5.2226C11.7605 5.152 11.7753 5.07632 11.775 4.99994C11.775 4.83938 11.7102 4.69413 11.6052 4.58869L11.6039 4.58738V4.58694L8.1039 1.08738C8.04974 1.03317 7.98543 0.990166 7.91464 0.960825C7.84385 0.931484 7.76797 0.916382 7.69134 0.916382C7.61471 0.916382 7.53883 0.931484 7.46804 0.960825C7.39725 0.990166 7.33294 1.03317 7.27878 1.08738Z" fill="rgba(234, 236, 239, 0.45)"></path></svg></p>
                           </div>
                           <ul>
                                {transactions.slice(0, 6).map((transaction, i) => (
                                    <li key={i}>
                                        <div className="data">
                                            <h2>{transaction.action !== "refill" ? t("transactions.conclusion") : t("transactions.despoit")}</h2>
                                            <p className="date">{formatDate(transaction.date)}</p>
                                        </div>
                                        <div className="data2">
                                            <p className={transaction.action === "refill" ? "sum" : "sum minus"}>
                                                {transaction.action === "refill" ? "+" : "-"} {transaction.value}
                                            </p>
                                            {returnStatus(transaction.status)}
                                        </div>
                                    </li>
                                ))}
                           </ul>
                        </div>
                    </div>

                    <MyCheck data={data} cursCb={cursCb} />   
                </div>
            </div>
        </div>
    )
}

export default Assets












// import React, { useState, useEffect, useMemo } from 'react' // <--- 1. Добавили useMemo
// import Header from '../../components/header/Header'
// import MyCheck from './MyCheck/MyCheck'
// import DepositBlock from './depositBlock/DepositBlock'
// import WithdrawalFunds from './WithdrawalFunds/WithdrawalFunds'
// import axios from 'axios'
// import './Assets.css'
// import { useNavigate } from 'react-router-dom'
// import { useTranslation } from 'react-i18next'

// const Assets = () => {
//     const { t } = useTranslation()

//     // ... (функции number_format, createSymbolString, calculateTotalValue оставляем как были) ...
//     function number_format(number, decimals, dec_point, thousands_sep) {
//         number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
//         var n = !isFinite(+number) ? 0 : +number,
//             prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
//             sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
//             dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
//             s = '',
//             toFixedFix = function (n, prec) {
//                 var k = Math.pow(10, prec);
//                 return '' + Math.round(n * k) / k;
//             };
//         s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
//         if (s[0].length > 3) {
//             s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
//         }
//         if ((s[1] || '').length < prec) {
//             s[1] = s[1] || '';
//             s[1] += new Array(prec - s[1].length + 1).join('0');
//         }
//         return s.join(dec);
//     }

//     function createSymbolString(currencyObject) {
//         const pairs = Object.keys(currencyObject).map((currency) => {
//             return currency.toUpperCase() + "USDT";
//         });
//         const filteredPairs = pairs.filter((pair) => pair !== "USDTUSDT");
//         return filteredPairs.length === 0 ? `symbols=["BNBBTC"]` : `symbols=${JSON.stringify(filteredPairs)}`;
//     }
    
//     // ... (код calculateTotalValue без изменений) ...
//     function calculateTotalValue(coinsPrice, currencyObject) {
//          let totalValue = 0;
//          coinsPrice.forEach((coin) => {
//              const { symbol, lowPrice } = coin;
//              const currency = symbol === "BNBBTC" ? "usdt" : symbol.replace("USDT", "").toLowerCase();
//              const lowpriceNew = symbol === "BNBBTC" ? 1 : lowPrice;
//              const rate = (currencyObject[currency] ? currencyObject[currency] : 0);
//              const lowPriceNum = parseFloat(lowpriceNew);
//              totalValue += lowPriceNum * rate;
//          });
//          return totalValue > 0 ? totalValue : 0;
//     }

//     const token = localStorage.getItem("token")
//     const navigate = useNavigate()

//     // --- STATES ---
//     const [AVGINVEST, setAVGINVEST] = useState(0);
//     const [AVGMAIN, setAVGMAIN] = useState(0);
//     const [AVGFUTURES, setAVGFUTURES] = useState(0);
    
//     const [AVGMAINLD, setAVGMAINLD] = useState(false);
//     const [AVGINVESTLD, setAVGINVESTLD] = useState(false);
//     const [AVGFUTURESLD, setAVGFUTURESLD] = useState(false);

//     const [balanceFiltered, setBalanceFiltered] = useState([])
//     const [balanceFilteredFutures, setBalanceFilteredFutures] = useState([])
//     const [balanceFilteredInvest, setBalanceFilteredInvest] = useState([])

//     const [AVGMAINLD22, setAVGMAINLD22] = useState(false); // Загрузился баланс
//     const [chekAVGBTC, setChekAVGBTC] = useState(false);   // Загрузился курс BTC
//     const [AVGBALANCE2, setAVGBALANCE2] = useState(0);
//     const [AVGMAIN2, setAVGMAIN2] = useState(0);
//     const [AVGFUTURES2, setAVGFUTURES2] = useState(0);
//     const [AVGINVEST2, setAVGINVEST2] = useState(0);
//     const [AVGBTC, setAVGBTC] = useState(0);

//     const [depositVisible, setDepositVisible] = useState(false)
//     const [withdrawalFundsVisible, setWithdrawalFundsVisible] = useState(false)

//     // --- ЗАГРУЗКА БАЛАНСОВ ---
//     const getBalances = () => {
//         // 1. Common Balance
//         axios.get(`https://api-ru.fynex.cc/api/api/users/balance/common`, { headers: { "Authorization": `Bearer ${token}` } })
//             .then(res => {
//                 setAVGBALANCE2(Math.floor10(res.data, -2))
//                 setAVGMAINLD22(true) // Баланс загружен
//             })
//             .catch(e => setAVGMAINLD22(true)); // Даже если ошибка, снимаем флаг загрузки, чтобы скелет пропал

//         // Остальные балансы...
//         axios.get(`https://api-ru.fynex.cc/api/api/users/balance/main/common`, { headers: { "Authorization": `Bearer ${token}` } })
//             .then(res => setAVGMAIN2(Math.floor10(res.data, -2)))
//         axios.get(`https://api-ru.fynex.cc/api/api/users/balance/futures/common`, { headers: { "Authorization": `Bearer ${token}` } })
//             .then(res => setAVGFUTURES2(Math.floor10(res.data, -2)))
//         axios.get(`https://api-ru.fynex.cc/api/api/users/balance/invest/common`, { headers: { "Authorization": `Bearer ${token}` } })
//             .then(res => setAVGINVEST2(Math.floor10(res.data, -2)))
//     }

//     // --- ЗАГРУЗКА КУРСА BTC (ОПТИМИЗИРОВАНО) ---
//     // Мы не ждем загрузки баланса, чтобы узнать курс BTC. Запрашиваем параллельно.
//     const [btcRate, setBtcRate] = useState(null); 

//     const getBtcRateOnly = () => {
//         axios.get('https://api-ru.fynex.cc/rates/rate?ticker=BTC&coin=USDT')
//         .then(res => {
//             setBtcRate(parseFloat(res.data));
//             setChekAVGBTC(true);
//         })
//         .catch(err => {
//             console.error(err);
//             setChekAVGBTC(true); // Снимаем скелет даже при ошибке
//         });
//     }

//     // Этот useEffect сработает один раз при запуске страницы
//     useEffect(() => {
//         getBalances();
//         getBtcRateOnly(); // <--- Запускаем сразу!
//         requireBalance();
//         requireBalanceFutures();
//         requireBalanceInvest();
//         getUserPortfolioData();
//         requireTransactions();
//     }, []);

//     // Отдельный эффект для пересчета баланса в BTC, когда пришли И баланс И курс
//     useEffect(() => {
//         if (AVGBALANCE2 && btcRate) {
//             setAVGBTC((parseFloat(AVGBALANCE2) / btcRate).toFixed(6)); // Сделал 6 знаков, для BTC 10 многовато
//         }
//     }, [AVGBALANCE2, btcRate]);


//     function filterKeysWithPositiveValues(obj) {
//         const filteredEntries = Object.entries(obj).filter(([key, value]) => value > 0 && key !== 'username_id' && key !== 'id');
//         return Object.fromEntries(filteredEntries);
//     }

//     // --- НОВАЯ ВЕРСИЯ requirePrice ДЛЯ N-TRUST API ---
//     const requirePrice = async (ignoredUrl, currencyObject, type) => {
//         const currencies = Object.keys(currencyObject);
//         if (currencies.length === 0) {
//             switch (type) {
//                 case "main": 
//                     setAVGMAIN(0); 
//                     setAVGMAINLD(true); // <--- Важно! Снимаем загрузку
//                     break;
//                 case "invest": 
//                     setAVGINVEST(0); 
//                     setAVGINVESTLD(true); // <--- Важно!
//                     break;
//                 case "futures": 
//                     setAVGFUTURES(0); 
//                     setAVGFUTURESLD(true); // <--- Важно!
//                     // setAVGLoaded(true); // Если используется где-то еще
//                     break;
//             }
//             return;
//         }

//         const promises = currencies.map(async (currency) => {
//             if (currency.toUpperCase() === 'USDT' || currency.toUpperCase() === 'USD') {
//                 return { symbol: currency, price: 1, amount: currencyObject[currency] };
//             }
//             if (currency === 'rub') return { symbol: currency, price: 0, amount: currencyObject[currency] };
            
//             try {
//                 const res = await axios.get(`https://api-ru.fynex.cc/rates/rate`, {
//                     params: { ticker: currency.toUpperCase(), coin: 'USDT' }
//                 });
//                 return { symbol: currency, price: parseFloat(res.data), amount: currencyObject[currency] };
//             } catch (e) {
//                 return { symbol: currency, price: 0, amount: currencyObject[currency] };
//             }
//         });

//         try {
//             const results = await Promise.all(promises);
//             let totalValue = 0;
//             results.forEach(item => {
//                  if (item.symbol !== 'rub') totalValue += (item.price * item.amount);
//             });

//             switch (type) {
//                 case "main": setAVGMAIN(totalValue); setAVGMAINLD(true); break;
//                 case "invest": setAVGINVEST(totalValue); setAVGINVESTLD(true); break;
//                 case "futures": setAVGFUTURES(totalValue); setAVGFUTURESLD(true); break;
//             }
//         } catch (error) { console.error(error); }
//     }

//     const requireBalance = () => {
//         axios.get(`https://api-ru.fynex.cc/api/api/users/balance`, {headers: {"Authorization" : `Bearer ${token}`}})
//             .then(res => {
//                 let balanceFilter = filterKeysWithPositiveValues(res.data)
//                 setBalanceFiltered(Object.entries(balanceFilter));
//                 requirePrice(null, balanceFilter, "main")
//             })
//     }
//     const requireBalanceInvest = () => {
//          axios.get(`https://api-ru.fynex.cc/api/api/users/balance/invest`, {headers: {"Authorization" : `Bearer ${token}`}})
//             .then(res => {
//                 let balanceFilter = filterKeysWithPositiveValues(res.data)
//                 setBalanceFilteredInvest(Object.entries(balanceFilter));
//                 requirePrice(null, balanceFilter, "invest")
//             })
//     }
//     const requireBalanceFutures = () => {
//         axios.get(`https://api-ru.fynex.cc/api/api/users/balance/futures`, {headers: {"Authorization" : `Bearer ${token}`}})
//            .then(res => {
//                let balanceFilter = filterKeysWithPositiveValues(res.data)
//                setBalanceFilteredFutures(Object.entries(balanceFilter));
//                requirePrice(null, balanceFilter, "futures")
//            })
//    }

//     const [transactions, setTransactions] = useState([])
//     const requireTransactions = () => {
//         axios.get(`https://api-ru.fynex.cc/api/api/transaction`, {headers: {"Authorization" : `Bearer ${token}`}})
//             .then(res => setTransactions(res.data))
//     }

//     // MATH Helper
//     (function() {
//         function decimalAdjust(type, value, exp) {
//             if (typeof exp === 'undefined' || +exp === 0) return Math[type](value);
//             value = +value; exp = +exp;
//             if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) return NaN;
//             value = value.toString().split('e');
//             value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
//             value = value.toString().split('e');
//             return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
//         }
//         if (!Math.floor10) Math.floor10 = function(value, exp) { return decimalAdjust('floor', value, exp); };
//     })();

//     const [cursCb, setCursCb] = useState(90);
//     // ... (cbc логика если нужна)

//     const [userPortfolioData, setUserPortfolioData] = useState() 
//     const getUserPortfolioData = () => {
//         axios.get("https://api-ru.fynex.cc/api/api/user/portfolio", {headers: {"Authorization": `Bearer ${token}`}})
//             .then(res => setUserPortfolioData(res.data))
//     }

//     function formatDate(inputDate) {
//         const date = new Date(inputDate);
//         return `${date.getFullYear().toString().substr(-2)}.${(date.getMonth()+1).toString().padStart(2,'0')}.${date.getDate().toString().padStart(2,'0')} ${date.getHours().toString().padStart(2,'0')}:${date.getMinutes().toString().padStart(2,'0')}`;
//     }
    
//     const returnStatus = (status) => {
//         if(status == "accepted") return <p className='accepted'>{t("transactions.accepted")}</p>
//         if(status == "waiting") return <p className='wait'>{t("transactions.wait")}</p>
//         if(status == "rejected") return <p className='rejected'>{t("transactions.rejected")}</p>
//     }

//     // --- ВАЖНОЕ ИСПРАВЛЕНИЕ: useMemo для DATA ---
//     // Это предотвращает мигание скелетонов в MyCheck.
//     // Мы создаем этот объект только когда реально меняются входящие данные.
//     // const data = useMemo(() => {
//     //     return [
//     //         { name: t("assets.futures"), value: ` BTC`, percentage: "%", usd: "USD", data: balanceFilteredFutures },
//     //         { name: t("assets.replenishment"), value: ` BTC`, percentage: "%", usd: "USD", data: balanceFiltered },
//     //         { name: t("assets.invest"), value: ` BTC`, percentage: "%", usd: "USD", data: balanceFilteredInvest },
//     //         { name: t("assets.portfel"), value: ` BTC`, percentage: "%", usd: "USD", data: userPortfolioData?.active === false ? [] : [["usd", userPortfolioData?.value]] },
//     //     ];
//     // }, [balanceFilteredFutures, balanceFiltered, balanceFilteredInvest, userPortfolioData, t]);

//     const data = useMemo(() => {
//         return [
//             { 
//                 name: t("assets.futures"), 
//                 value: ` BTC`, 
//                 percentage: "%", 
//                 usd: "USD", 
//                 data: balanceFilteredFutures,
//                 // Добавляем флаг: грузятся ли еще фьючерсы?
//                 isLoading: !AVGFUTURESLD 
//             },
//             { 
//                 name: t("assets.replenishment"), 
//                 value: ` BTC`, 
//                 percentage: "%", 
//                 usd: "USD", 
//                 data: balanceFiltered,
//                 // Грузится ли спот? (используем bf1l или AVGMAINLD, смотря что раньше срабатывает, лучше bf1l из requireBalance)
//                 isLoading: !AVGMAINLD 
//             },
//             { 
//                 name: t("assets.invest"), 
//                 value: ` BTC`, 
//                 percentage: "%", 
//                 usd: "USD", 
//                 data: balanceFilteredInvest,
//                 isLoading: !AVGINVESTLD 
//             },
//             { 
//                 name: t("assets.portfel"), 
//                 value: ` BTC`, 
//                 percentage: "%", 
//                 usd: "USD", 
//                 data: userPortfolioData?.active === false ? [] : [["usd", userPortfolioData?.value]],
//                 // Портфель грузится, если userPortfolioData еще undefined
//                 isLoading: !userPortfolioData 
//             },
//         ];
//     }, [balanceFilteredFutures, balanceFiltered, balanceFilteredInvest, userPortfolioData, AVGFUTURESLD, AVGMAINLD, AVGINVESTLD, t]);

//     // Определяем общий флаг загрузки для шапки (баланс и BTC курс)
//     const isHeaderLoading = !AVGMAINLD22 || !chekAVGBTC;

//     return (
//         <div className='Assets'>
//             <div className="WrapperBlock" style={{visibility: depositVisible || withdrawalFundsVisible ? "visible" : "hidden"}}>
//                 <DepositBlock state={depositVisible} setState={setDepositVisible}/>
//                 <WithdrawalFunds state={withdrawalFundsVisible} setState={setWithdrawalFundsVisible}/>
//             </div>

//             <Header hasMenu2={true}/>
//             <div className="assetsWrapper">
//                 <div className="wrapperBlocks">
//                     <div className="section">
//                         <div className="myActiv">
//                             <h2>{t("assets.myActive")}</h2>
//                             <div className="countActiv">
//                                 <p>{t("assets.countActive")}</p>
                                
//                                 {/* СКЕЛЕТОН БЕЗ МИГАНИЯ */}
//                                 {isHeaderLoading ? (
//                                     <div className="skeleton" style={{ width: '220px', height: '36px', marginTop: '10px' }}></div>
//                                 ) : (
//                                     <h2>{AVGBTC} BTC <span> {number_format(AVGBALANCE2, 2)} USD</span></h2>
//                                 )}
//                             </div>
//                             <p className='usd'></p>
//                         </div>
                        
//                         <div className="btnMenu">
//                             <button onClick={()=>setDepositVisible(true)}><p>{t("assets.deposit")}</p></button>
//                             <button onClick={()=>setWithdrawalFundsVisible(true)}><p>{t("assets.conclusion")}</p></button>
//                             <button onClick={()=>navigate('/convert')}><p>{t("assets.convert")}</p></button>
//                             <button onClick={()=>navigate('/account/wallet')}><p>{t("assets.transfer")}</p></button>
//                         </div>

//                         <div className="lastTransaction">
//                            <div className="headline">
//                                 <h2>{t("assets.lastTransactions")}</h2>
//                                 <p onClick={()=>{navigate("/transactions")}}>{t("assets.more")}<svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.27878 1.08738C7.22457 1.14154 7.18156 1.20585 7.15222 1.27664C7.12288 1.34743 7.10778 1.42331 7.10778 1.49994C7.10778 1.57657 7.12288 1.65245 7.15222 1.72324C7.18156 1.79403 7.22457 1.85834 7.27878 1.91251L9.78303 4.41676H0.691342C0.536671 4.41676 0.388335 4.4782 0.278966 4.58757C0.169597 4.69694 0.108154 4.84527 0.108154 4.99994C0.108154 5.15461 0.169597 5.30295 0.278966 5.41232C0.388335 5.52169 0.536671 5.58313 0.691342 5.58313H9.78303L7.27878 8.08738C7.16936 8.1968 7.10789 8.3452 7.10789 8.49994C7.10789 8.65468 7.16936 8.80309 7.27878 8.91251C7.3882 9.02192 7.5366 9.0834 7.69134 9.0834C7.84608 9.0834 7.99449 9.02192 8.1039 8.91251L11.6039 5.41294V5.41251L11.6052 5.41119C11.6593 5.3573 11.7022 5.2932 11.7314 5.2226C11.7605 5.152 11.7753 5.07632 11.775 4.99994C11.775 4.83938 11.7102 4.69413 11.6052 4.58869L11.6039 4.58738V4.58694L8.1039 1.08738C8.04974 1.03317 7.98543 0.990166 7.91464 0.960825C7.84385 0.931484 7.76797 0.916382 7.69134 0.916382C7.61471 0.916382 7.53883 0.931484 7.46804 0.960825C7.39725 0.990166 7.33294 1.03317 7.27878 1.08738Z" fill="#F3F3F3" fillOpacity="0.4"></path></svg></p>
//                            </div>
//                            <ul>
//                                 {transactions.slice(0, 6).map((transaction, i) => (
//                                     <li key={i}>
//                                         <div className="data">
//                                             <h2>{transaction.action !== "refill" ? t("transactions.conclusion") : t("transactions.despoit")}</h2>
//                                             <p className="date">{formatDate(transaction.date)}</p>
//                                         </div>
//                                         <div className="data2">
//                                             <p className={transaction.action === "refill" ? "sum" : "sum minus"}>
//                                                 {transaction.action === "refill" ? "+" : "-"} {transaction.value}
//                                             </p>
//                                             {returnStatus(transaction.status)}
//                                         </div>
//                                     </li>
//                                 ))}
//                            </ul>
//                         </div>
//                     </div>

//                     <MyCheck data={data} cursCb={cursCb} />   
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default Assets
